import { all } from 'redux-saga/effects'

import watchDeclineReasonsSaga from './declineReasons'
import watchInterviewRequestsSaga from './interviewRequests'
import watchNewCandidatesSaga from './newCandidates'
import watchPositionsSaga from './positions'
import watchProfileViewsSaga from './profileViews'
import watchQuarterRatesSaga from './quarterRates'
import watchRatesSaga from './rates'

export default function* hiringAnalyticsSaga() {
  yield all([
    watchDeclineReasonsSaga(),
    watchInterviewRequestsSaga(),
    watchNewCandidatesSaga(),
    watchPositionsSaga(),
    watchProfileViewsSaga(),
    watchQuarterRatesSaga(),
    watchRatesSaga(),
  ])
}
